import type { NAccessRights, NFiles, NSmallGlobalEntities } from '@app/types';
import type { NBranches } from '@app/types/Branches';

/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: здесь тип Any планируется убрать отдельным этапом в рамках task/3444,
// т.к. у нас завязано много мест в кодовой базе на accessRights

export namespace NAuth {
  export type AuthInitialState = {
    user: User;
    accessRights: NAccessRights.ModelAccessRights | null;
    activeBranchName: NBranches.ExistedBranch['name'] | null;
    activeBranchCountryId: number | null;
    // Список организаций вошедшего пользователя. Приходит в ModelAuthentication
    // при любом входе (по паролю/коду/секрету/cookie). Меньше двух элементов —
    // переключать нечего (US 10910).
    organizations: ModelOrganizationAuth[];
  };

  // Организация в списке доступных вошедшему пользователю (US 10910).
  export type ModelOrganizationAuth = {
    Id: number;
    Name: string | null;
    // Признак текущей (активной) организации пользователя.
    IsCurrent: boolean;
  };

  export interface UserPrint {
    userId: number | null;
    database: string | null;
    activeBranchId: number | null;
  }

  export interface User extends UserPrint {
    nameFirst: NAuth.ModelAuthentication['NameFirst'];
    nameLast: NAuth.ModelAuthentication['NameLast'];
    email: NAuth.ModelAuthentication['Email'];
    phone: NAuth.ModelAuthentication['Phone'];
    gender: NSmallGlobalEntities.Gender;
    photo: NFiles.ModelPhoto['PhotoBase64'];
    dateBirth: NAuth.ModelAuthentication['DateBirth'];
    isAdmin: boolean;
    accessCode: NAuth.ModelAuthentication['AccessCode'];
    position: NAuth.ModelAuthentication['Position'];
    telCode: string;
  }

  export type ModelAuthentication = {
    UserId: number;
    Database: string | null;
    NameLast: string | null;
    NameFirst: string | null;
    NameMiddle: string | null;
    Email: string | null;
    Password: string | null;
    Phone: string | null;
    Gender: NSmallGlobalEntities.Gender;
    Photo: string | null;
    DateBirth: string | null;
    IsAdmin: boolean;
    AccessCode: string | null;
    CookieData: string | null;
    CookieEmail: string | null;
    AccessToken: string | null;
    Position: string | null;
    ActiveBranchId: number;
    AccessRights: NAccessRights.ModelAccessRights;
    Organizations: ModelOrganizationAuth[] | null;
  };

  export type ModelAuthByPassword = {
    Email: string | null;
    Password: string | null;
  };
}
